<div class="spec-table__overlay">
  <div class="sticky-element">
    <div class="spec-table__header">
      <app-compare-header
        (closed)="onClose($event)"
        [hasSpecDifferences]="hasSpecDifferences"
      ></app-compare-header>
    </div>
    <div class="spec-table__comparisons">
      <div class="container padding--none">
        <div class="content">
          <app-compare-cards
            [comparisons]="comparisons"
            (selected)="onSelected($event)"
            (removed)="onRemove($event)"
          >
          </app-compare-cards>
        </div>
        <app-checkbox
          *ngIf="hasSpecDifferences"
          [isChecked]="toggleSpecDifferences"
          (checked)="toggleSpecDifferencesChecked()"
        >
          <strong>Only show differences</strong>
        </app-checkbox>
      </div>
    </div>
  </div>
  <div class="spec-table__table">
    <div class="container padding--none">
      <app-spec-table
        [comparisons]="comparisons"
        [filtered]="toggleSpecDifferences"
      ></app-spec-table>
    </div>
  </div>
</div>
